import Vue from 'vue';
import moment from 'moment';
import axios from 'axios';

export default Vue.component('contract-detail', {
    data: () => ({
        axe: axios.create({
            baseURL: '/mywecycle/contract'
        }),
        loading: false,
    }),
    computed: {
        isDownloadableContract() {
            // A contract is considered downloadable when it's in status agreed, terminationRequested, terminated or terminationAccepted and not autoapproved
            const statusActive = [2,3,4,6].includes(this.contract.status);
            return statusActive && !(this.contract.type === 5 || this.contract.type === 6);
        },
        isParticipationAgreement() {
            return this.contract.type === 1;
        },
        isGenerallyBindingStatementRequestLightRec() {
            return this.contract.type === 2;
        },
        isParticipationAgreementWecycle() {
            return this.contract.type === 3;
        },
        isBasicCollectionAgreement() {
            return this.contract.type === 4;
        },
        agreedToAllTerms() {
            return this.terms.every(t => t.agreedTo);
        },
        validationMessages() {
            const unagreedTerms = this.terms.filter(t => !t.agreedTo);
            let validationMessages = [];

            unagreedTerms.forEach(t => {
                validationMessages.push(t.validationMessage);
            });

            return validationMessages;
        },
        parsedFiles() {
            let files = [];
            this.files.forEach(f => {
                f.dateTimeFormatted = moment(f.dateTime).format('DD-MM-YYYY - HH:MM');
                files.push(f);
            })
            return files;
        },
        isBOuser() {
            return utils.isBoUser();
        }
    },
    methods: {
        removeAttachment(e) {
            e.preventDefault();
            const target = e.currentTarget;
            const url = target.getAttribute('href');
            const id = target.getAttribute('data-file-id');
            const msg = target.getAttribute('data-confirmation-msg');
            const confirm = window.confirm(msg);

            // get file index for removing it later on
            const index = _.findIndex(this.files, function(f) { 
                return f.fileId === parseInt(id); 
            });

            if (!confirm) {
                return;
            }
            
            this.loading = true;

            // Make API call, on success remove attachment from model so that the view updates
            axios.get(url)
                .then((resp) => {
                    
                    if(!resp.data.HasErrors) { 
                        // slice this.files
                        this.files.splice(index, 1);

                        // show msg
                        One.helpers('notify', { type: 'success', icon: 'fa fa-check mr-1', message: resp.data.Message });

                    } else {
                        // show msg
                        One.helpers('notify', { type: 'warning', icon: 'fa fa-exclamation-mark mr-1', message: resp.data.Message });
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        acceptAgreement() {
            this.loading = true;

            let response;
            this.axe.post("/ContractAgreement", this.contract)
                .then((resp) => {
                    response = resp.data;
                    if (response.hasErrors) {
                        One.helpers('notify', { type: response.notification.type, icon: 'fa fa-exclamation-triangle mr-1', message: response.notification.content });
                    } else {
                        window.location.href = response.redirectUrl;
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        requestTermination() {
            this.loading = true;

            let response;
            this.axe.post("/RequestTermination", this.contract)
                .then((resp) => {
                    response = resp.data;
                    if (response.hasErrors) {
                        One.helpers('notify', { type: response.notification.type, icon: 'fa fa-exclamation-triangle mr-1', message: response.notification.content });
                    } else {
                        window.location.href = response.redirectUrl;
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });

        },
        downloadContract() {
            window.open(this.axe.defaults.baseURL + "/DownloadContract?ContractId=" + this.contract.contractId);
        },
        downloadExampleContract() {
            // Make sure terms are loaded and downloadExampleContract term exists
            if (this.terms.length > 0) {
                const downloadExampleContractTerm = this.terms.find(t => t.key === "DownloadExampleContract");
                if (downloadExampleContractTerm && !downloadExampleContractTerm.agreedTo) {
                    downloadExampleContractTerm.agreedTo = true;
                }
            }
            
            window.open(this.axe.defaults.baseURL + "/DownloadExampleContract?ContractId=" + this.contract.contractId);
        },
        optOut() {
            this.openModal('modal-contract-opt-out');
        },
        openModal(id) {
            window.$('#' + id).modal('show');
        }
    }
});